"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaObject = exports.MediaBody = exports.Media = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Media = _styledComponents["default"].div.withConfig({
  displayName: "Media",
  componentId: "s2vb9q-0"
})(["--mediaObjectSpacing:", ";display:flex;align-items:", ";flex-direction:column;@media screen and (min-width:", "){flex-direction:row;}"], function (props) {
  return props.$spacing || '20px';
}, function (props) {
  return props.center || props.$center ? 'center' : 'flex-start';
}, function (_ref) {
  var theme = _ref.theme;
  return theme.screenMedium;
});

exports.Media = Media;
Media.propTypes = {
  /**
   * Spacing between MediaObject and MediaBody.
   */
  $spacing: _propTypes["default"].string,

  /**
   * Center MediaObject(on smaller viewports, when MediaBody is wrapped)
   */
  $center: _propTypes["default"].bool,

  /**
   * Deprecated. See $center.
   */
  center: _propTypes["default"].bool
};

var MediaBody = _styledComponents["default"].div.withConfig({
  displayName: "Media__MediaBody",
  componentId: "s2vb9q-1"
})(["flex-grow:1;"]);

exports.MediaBody = MediaBody;

var MediaObject = _styledComponents["default"].div.withConfig({
  displayName: "Media__MediaObject",
  componentId: "s2vb9q-2"
})(["", " @media screen and (min-width:", "){& + ", ",", " + &{margin-left:var(--mediaObjectSpacing);}}@media screen and (max-width:", "){& + ", ",", " + &{margin-top:var(--mediaObjectSpacing);}}"], function (_ref2) {
  var $preserveSize = _ref2.$preserveSize;
  return $preserveSize && (0, _styledComponents.css)(["flex-shrink:0;"]);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.screenMedium;
}, MediaBody, MediaBody, function (_ref4) {
  var theme = _ref4.theme;
  return theme.screenMediumMax;
}, MediaBody, MediaBody);

exports.MediaObject = MediaObject;
MediaObject.propTypes = {
  /**
   * Don't shrink MediaObject on if there is not engough width
   */
  $preserveSize: _propTypes["default"].bool
};